import { init, setGroup, setUserId } from '@amplitude/analytics-browser';

import { environment } from '../../config/appEnvironment';

const { REACT_APP_AMPLITUDE_API_KEY } = environment;

class Amplitude {
  init() {
    init(REACT_APP_AMPLITUDE_API_KEY, {
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true
      }
    }).promise.then(() => setGroup('appName', 'stne-workforce-components'));
  }

  setProfile(profileName) {
    setGroup('profile', profileName);
  }

  setUserId(userEmail) {
    setUserId(userEmail);
  }
}

export default new Amplitude();
